import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import { ReactComponent as ClipIcon } from "../../../../design/assests/images/icons/paperclip.svg"
import { createVacationRequest } from "../../../../services/vacation.service"
import useToast from "../../../../hooks/useToast.hook"
import VacationCreateRequestSummary from "../../components/VacationCreateRequestSummary.molecule"
import _ from "lodash"
import {
  getMaxStartDate,
  isMexicanSchema,
} from "../../../../utils/vacation.utils"
import useMyVacationRequestFormState, {
  VACATION_REQUEST_FORM_MODE,
} from "../../../../hooks/useMyVacationRequestFormState.hook"
import useMyVacationRequestMaxDate from "../../../../hooks/useVacationMaxDate.hook"
import { MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE } from "../../../../consts/modules/vacations.consts"
import { DateTime } from "luxon"

const ModalCreateMyVacationRequest = ({
  holidaySchemaId,
  visible,
  setVisible,
  selectedPeriod,
  triggerRefresh,
}) => {
  // Form States
  const {
    // States
    formData,
    setFormData,
    validations,
    setValidations,
    availableDaysList,
    disabledDayList,
    bucketDaysList,
    plusDaysList,
    accordedDaysList,
    multipleDays,
    setMultipleDays,
    daysToUse,
    typesOfDaysToUse,
    disabledSaveButton,
    allowFormStateChanges,
    setAllowFormStateChanges,
    loading,
    anniversaryDate,

    // Functions
    updateDaysToUse,
    resetForms,

    // Services
    updateTeamMemberBucketDaysTest,
    updateAvailableBucketDaysBasedOnPeriodChange,
    updateAvailablePlusDaysBasedOnPeriodChange,
    updateAvailableAccordedDaysBasedOnPeriodChange,
    updateDisabledDayList,
    updateAvailableDaysList,
    updateTeamMemberPlusDays,
  } = useMyVacationRequestFormState({
    holidaySchemaId,
    vacationRequestFormMode: VACATION_REQUEST_FORM_MODE.CREATE,
  })
  const { maxDate, updateMaxDate } = useMyVacationRequestMaxDate()
  const [submitting, setSubmitting] = useState(false)
  // Hooks
  const { setErrorMessage } = useToast()
  
  useEffect(() => {
    if (visible) {
      const initModalForm = async () => {
        const startDate = DateTime.max(
          DateTime.fromISO(selectedPeriod[0]),
          MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE
        )
        // const startDate = DateTime.fromISO(selectedPeriod[0])
        await updateAvailableDaysList(
          selectedPeriod[0],
          selectedPeriod[1],
          holidaySchemaId
        )
        await updateDisabledDayList(
          selectedPeriod[0],
          selectedPeriod[1].plus({ years: 10 })
        )
        await updateTeamMemberBucketDaysTest(
          startDate,
          selectedPeriod[1],
          holidaySchemaId
        )
        await updateTeamMemberPlusDays(
          selectedPeriod[0],
          selectedPeriod[1],
          holidaySchemaId
        )
        setAllowFormStateChanges(true)
      }
      initModalForm()
    } else {
      resetForms()
    }
  }, [visible])

  useEffect(() => {
    if (allowFormStateChanges) {
      
      updateDaysToUse(
        formData.requestDates[0],
        formData.requestDates[1],
        disabledDayList
      )
      updateMaxDate(
        formData.requestDates[0],
        holidaySchemaId && isMexicanSchema(holidaySchemaId) ?
          availableDaysList.bucketDays + 3
        : 0,
        availableDaysList.plusDays,
        availableDaysList.accordedDays,
        availableDaysList.additionalDays,
        disabledDayList
      )
      if (holidaySchemaId && isMexicanSchema(holidaySchemaId)) {
        updateAvailableBucketDaysBasedOnPeriodChange(
          formData.requestDates[0],
          formData.requestDates[1],
          bucketDaysList || {}
        )
        updateAvailablePlusDaysBasedOnPeriodChange(
          formData.requestDates[0],
          formData.requestDates[1],
          plusDaysList || {}
        )
        updateAvailableAccordedDaysBasedOnPeriodChange(
          formData.requestDates[0],
          formData.requestDates[1],
          accordedDaysList || {}
        )
   
      }
       updateAvailableAccordedDaysBasedOnPeriodChange(
          formData.requestDates[0],
          formData.requestDates[1],
          accordedDaysList || {}
        )
    }
  }, [formData.requestDates, allowFormStateChanges])

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await createVacationRequest(formData, selectedPeriod)
      if (!response.success) {
        throw new Error(response.message)
      }
      setVisible("")
      triggerRefresh()
    } catch (error) {
      setErrorMessage({
        title: "Error",
        message: error.message,
      })
    }
    setSubmitting(false)
  }

  const handleModalSetVisibility = (visibleModal) => {
    if (!visibleModal) {
      setVisible("")
    }
  }

  return (
    <ModalForm
      className="my-vacation-create-modal-form"
      visible={visible}
      setVisible={handleModalSetVisibility}
      headerTitle="Solicitar vacaciones"
      headerIcon={<ClipIcon />}
      dismissableMask
      closable
      saveLabel="Enviar"
      disabledSaveBtn={submitting || disabledSaveButton}
      onSave={handleSubmit}
      disable
      cleanUp={() => {
        resetForms()
      }}
    >
      <VacationCreateRequestSummary
        multipleDays={multipleDays}
        setMultipleDays={setMultipleDays}
        daysToUse={daysToUse}
        typesOfDaysToUse={typesOfDaysToUse}
        maxStartDate={getMaxStartDate(bucketDaysList, selectedPeriod[1])}
        maxDate={maxDate}
        vacationRequestValues={formData}
        setVacationRequestValues={setFormData}
        vacationRequestValidation={validations}
        setVacationsRequestValidation={setValidations}
        selectedPeriod={[
          DateTime.max(
            DateTime.fromISO(selectedPeriod[0]),
            MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE
          ),
          DateTime.fromISO(selectedPeriod[1]),
        ]}
        availableDaysList={availableDaysList}
        disabledDayList={disabledDayList}
        holidaySchemaId={holidaySchemaId}
        bucketDaysList={bucketDaysList}
        reminderTitle="¿A dónde vas tan rápido?"
        reminderBody="Una vez enviada, tu solicitud quedará pendiente de aprobación por el administrador. Mientras esperas, podrás editarla o cancelarla si lo necesitas."
        vacationFormMode={VACATION_REQUEST_FORM_MODE.CREATE}
        disabled={loading}
        anniversaryDate={anniversaryDate}
      />
    </ModalForm>
  )
}

export default ModalCreateMyVacationRequest

ModalCreateMyVacationRequest.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  triggerRefresh: PropTypes.func,
}
